import { ref } from 'vue'

// Sessões dos agentes (Ctrl+Shift+S, permissão sessions.manage): App.vue abre/fecha pelo atalho,
// SessionAdminModal.vue mostra. Estado de módulo pra qualquer lugar poder abrir o popup.
export const sessionAdminOpen = ref(false)
